import '../Popup.css'
import React, { useState } from 'react'
import endpoints from '../endpoints.json'

const Popup = ({ isOpen, children, onClose, log }) => {
  const [comment, setComment] = useState('')

  if (!isOpen) return null

  const handleInputChange = (e) => {
    setComment(e.target.value)
  }

  // Optional: Function to handle form submission or input confirmation
  const handleSubmit = () => {
    log({ comment: comment })

    onClose()
    // Closes the popup after submission
  }

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div class="one-ux-typography--heading-500">Input comment</div>

        <one-ux-field label="Comment">
          <one-ux-textarea
            line-count="4"
            placeholder="Type your comment here"
            value={comment}
            onChange={handleInputChange}></one-ux-textarea>
        </one-ux-field>

        <one-ux-button
          class="popup-button"
          label="Submit"
          purpose="default"
          weight="normal"
          state="default"
          onClick={handleSubmit}>
          {' '}
        </one-ux-button>
        <one-ux-button
          class="popup-button"
          label="Close"
          purpose="default"
          weight="normal"
          state="default"
          onClick={onClose}>
          {' '}
        </one-ux-button>
      </div>
    </div>
  )
}

export default Popup
